import type { TPostAudioElement } from '@shared/dream-components';
import { PostAudioElement } from '@shared/dream-components';

import type { TextToSpeechConfig } from '~/interfaces/post';

interface Props {
  textToSpeechConfig: TextToSpeechConfig;
}

const PostAudio = ({ textToSpeechConfig }: Props) => {
  return (
    <PostAudioElement
      element={
        {
          type: 'postAudio',
          attrs: {
            id: '',
            elementId: 'beehiiv-audio-tts-id',
            padding: `0 ${textToSpeechConfig.audio_padding}px`,
            data: {
              audioUrl: textToSpeechConfig.audio_url,
            },
          },
        } as TPostAudioElement
      }
      isLive
    >
      {null}
    </PostAudioElement>
  );
};

export { PostAudio };
